module.exports = __webpack_public_path__ + "img/ico_user--bl.391bba2d.svg";